import type { DocNode } from '@atlaskit/adf-schema/doc';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { type StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';
import { ROVO_AGENT_NAMED_ID } from '@atlassian/conversation-assistant-utils/default-agent';

export const createStoreAssistant = (args: {
	id: string;
	content: string | DocNode;
	agentNamedId?: string;
	agentAuthorId?: string;
	agentAuthorIdentityAccountId?: string;
	conversationId?: string;
	entryPoint?: string;
	actionId?: string;
}): StoreAssistant => {
	const mentionAgentsEnabled = isExperimentEnabled('rovo_chat_mention_agents');
	const authorNamedId = args.agentAuthorId ?? args.agentNamedId;
	const authorIdentityAccountId = args.agentAuthorIdentityAccountId?.trim() || undefined;

	return {
		type: 'ASSISTANT',
		...(args.entryPoint ? { entryPoint: args.entryPoint } : {}),
		...(args.actionId ? { actionId: args.actionId } : {}),
		content: {
			type: 'FINAL_RESPONSE',
			message: {
				message: {
					role: 'ASSISTANT',
					id: args.id,
					conversation_channel_id: args.conversationId,
					content: args.content,
					time_created: new Date().toISOString(),
					user_ari: 'unknown',
					plugin_invocations: [],
					...(args.agentAuthorId ? { agent_author: { id: args.agentAuthorId } } : {}),
					author: {
						...(mentionAgentsEnabled
							? {}
							: {
									// Remove this named-id control branch with `rovo_chat_mention_agents`.
									named_id: authorNamedId || ROVO_AGENT_NAMED_ID,
								}),
						name: 'unknown',
						actor_type: 'AGENT',
						ari: authorIdentityAccountId ?? null,
						identity_account_id: authorIdentityAccountId,
						id: args.agentAuthorId ?? 'unknown',
					},
				},
			},
		},
	};
};
